import React from 'react';
import { motion } from 'framer-motion';
const team = [{
  name: 'Caspian Delacroix',
  role: 'Chief Storyteller',
  description: 'Master of narrative and content strategy with 12 years in educational publishing.',
  color: 'bg-gradient-to-br from-purple-400 to-purple-600'
}, {
  name: 'Ottilie Brennvik',
  role: 'Head of School Partnerships',
  description: 'Former school administrator who builds bridges between EdTech and education.',
  color: 'bg-gradient-to-br from-pink-400 to-pink-600'
}, {
  name: 'Leander Mukherjee',
  role: 'Creative Director',
  description: 'Award-winning designer specializing in playful, accessible educational experiences.',
  color: 'bg-gradient-to-br from-blue-400 to-blue-600'
}, {
  name: 'Seren Okafor-Bliss',
  role: 'Content Strategist',
  description: 'Data-driven content expert who turns insights into engaging educational campaigns.',
  color: 'bg-gradient-to-br from-green-400 to-green-600'
}];
export function Team() {
  return <section id="team" className="py-20 px-4 bg-gradient-to-br from-blue-50 to-purple-50" data-id="element-195">
      <div className="max-w-7xl mx-auto" data-id="element-196">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-197">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-198">
            The Goblins Behind the Magic 🧙‍♂️
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-199">
            Meet the passionate team dedicated to transforming educational
            marketing
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-200">
          {team.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} whileHover={{
          y: -8
        }} className="bg-white rounded-3xl overflow-hidden shadow-xl" data-id="element-201">
              {/* Avatar Circle */}
              <div className="flex justify-center pt-8 pb-4" data-id="element-202">
                <div className={`${member.color} w-32 h-32 rounded-full flex items-center justify-center text-white text-4xl font-bold shadow-lg`} data-id="element-203">
                  {member.name.split(' ').map(n => n[0]).join('')}
                </div>
              </div>

              {/* Info */}
              <div className="p-6 text-center" data-id="element-204">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-205">
                  {member.name}
                </h3>
                <p className="text-purple-600 font-semibold mb-3" data-id="element-206">
                  {member.role}
                </p>
                <p className="text-gray-600" data-id="element-207">{member.description}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}